import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';
import { readCookie, writeCookie } from '@utils/cookie';

const LANGUAGE_COOKIE = 'lang';

const LANGUAGES = [
    { value: 'en', label: 'ENGLISH' },
    { value: 'es', label: 'ESPAÑOL' },
];

const LanguageDropdown = () => {
    const { pathname } = useLocation();
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!isOpen) return;

        const onDocumentClick = (event: MouseEvent) => {
            if (!containerRef.current?.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('click', onDocumentClick);

        return () => document.removeEventListener('click', onDocumentClick);
    }, [isOpen]);

    if (!pathname.includes('/register')) return null;

    const language = readCookie(LANGUAGE_COOKIE) ?? 'en';

    const onSelect = (value: string) => {
        writeCookie(LANGUAGE_COOKIE, value);

        window.location.reload();
    };

    return (
        <div className={'dropdown' + (isOpen ? ' open' : '')} ref={containerRef}>
            <button
                type="button"
                className="btn btn-default dropdown-toggle language-button"
                id="dropdownMenu1"
                aria-haspopup="true"
                aria-expanded={isOpen}
                style={{
                    backgroundColor: 'white',
                    height: 24,
                    border: 'none',
                    paddingBottom: 25,
                }}
                onClick={() => setIsOpen(!isOpen)}
            >
                {language === 'en' ? 'ENGLISH' : 'ESPAÑOL'}&nbsp;
                <span className="caret"></span>
            </button>

            <ul className="dropdown-menu" aria-labelledby="dropdownMenu1">
                {LANGUAGES.map((option) => (
                    <li key={option.value}>
                        <a
                            href="#"
                            onClick={(event) => {
                                event.preventDefault();
                                onSelect(option.value);
                            }}
                        >
                            <span className="value">{option.label}</span>
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default LanguageDropdown;
